import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import errorImg from "../404.svg";
import Copyright from "../components/Copyright";
import { FooterLinks } from "../components/layout/Footer";

export default function NotFound() {
  return (
    <div id="layoutError">
      <div id="layoutError_content">
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="text-center mt-4">
                  <img className="mb-4 img-error" src={errorImg} alt="404" />
                  <p className="lead">
                    This requested URL was not found on this server.
                  </p>
                  <Link to="/engines">
                    <FontAwesomeIcon
                      icon="arrow-left"
                      className="mr-1"
                    ></FontAwesomeIcon>
                    Return to safety
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <div id="layoutError_footer">
        <footer className="py-4 bg-light mt-auto">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between small">
              <Copyright />
              <div>
                <FooterLinks />
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
